<label>{{ label }}</label>
<div class="filter-chips-container">
  <input
    #inputEl
    type="text"
    [(ngModel)]="inputValue"
    (ngModelChange)="inputChange.emit($event ?? '')"
    [matAutocomplete]="auto"
    [disabled]="disabled"
    [placeholder]="placeholder"
    class="filter-input">
    @if (selected.length > 0) {
      <div class="chips-wrapper">
        <mat-chip-set>
          @for (item of selected; track item) {
            <mat-chip [removable]="true" (removed)="onRemove(item)">
              {{ item }}
              <button matChipRemove>
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip>
          }
        </mat-chip-set>
      </div>
    }
  </div>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
    @for (option of options; track option) {
      <mat-option [value]="option">
        {{ option }}
      </mat-option>
    }
  </mat-autocomplete>
